var mobileBp = 768;
var tabletBp = 992;
export var BREAKPOINTS = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop'
};
export function getBreakpoint() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  var deviceSize = window.innerWidth;
  if (deviceSize < mobileBp) {
    return BREAKPOINTS.MOBILE;
  }
  if (deviceSize < tabletBp) {
    return BREAKPOINTS.TABLET;
  }
  return BREAKPOINTS.DESKTOP;
}